import { getAdminFeatureFlagsSlice } from './get';

export const { requestGetAdminFeatureFlags, resetGetAdminFeatureFlags } =
    getAdminFeatureFlagsSlice.asyncActionCreators;

export * from './_id/actions';
